<template>
     <v-dialog
      v-model="diagToggle"
      max-width="500px"
      scrollable
      @input="v => v || handleClose()"
      @keydown.esc="handleClose"
     >
        <v-card>
          <v-card-title class="headline">
              Recherche
              <v-spacer></v-spacer>
            <v-btn icon flat @click.stop="handleClose">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <slot>
              Form comes here
            </slot>

          </v-card-text>

          <v-card-actions>
            <v-btn flat v-if="hasAdvanced" @click.stop="toggleAdvanced">
              <v-icon v-if="advanced">remove</v-icon>
              <v-icon v-if="!advanced">add</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="handleReset">
              <v-icon>autorenew</v-icon>
            </v-btn>
            <v-btn color="primary" @click.stop="handleSave">
              <v-icon>search</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
export default {
  computed: {
    diagToggle: {
      get () { return this.dialog },
      set (value) { this.handleClose() },
    },
  },
  props: {
    dialog: Boolean,
    hasAdvanced: {type: Boolean, default: false},
    advanced: {type: Boolean, default: false},
    toggleAdvanced: Function,
    handleSave: Function,
    handleReset: Function,
    handleClose: {
      type: Function,
      required: true,
    },
  },
}
</script>
